import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import FastClick from 'fastclick'
import 'animate.css'
// 这块一定要加,否者会有部分动画无法执行
import 'animate.css/animate.compat.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import './assets/style/index.less'
import './hooks/BaiduStatistics'
import "swiper/swiper.min.css"
import { library } from '@fortawesome/fontawesome-svg-core'
import 'font-awesome/css/font-awesome.min.css'

import { 
  faBell,
  faMicrochip,
  faCube,
  faImage,
  faCloud,
  faLayerGroup,
  faCommentDots,
  faEye,
  faWaveSquare,
  faStar as faSolidStar,
  faArrowRight,
  faBolt,
  faStore,
  faShieldHalved,
  faScaleBalanced,
  faFileInvoiceDollar,
  faUserGear,
  faArrowUp
} from '@fortawesome/free-solid-svg-icons'
import { 
  faStar
} from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
// FastClick.attach(document.body)
// import myWOW from './hooks/wow'
// // 初始化 wow.js
// myWOW()
library.add(
  faBell,
  faMicrochip,
  faCube,
  faImage,
  faCloud,
  faLayerGroup,
  faCommentDots,
  faEye,
  faWaveSquare,
  faSolidStar,
  faStar,
  faArrowRight,
  faBolt,
  faStore,
  faShieldHalved,
  faScaleBalanced,
  faFileInvoiceDollar,
  faUserGear,
  faArrowUp
)

createApp(App)
  .component('font-awesome-icon', FontAwesomeIcon)
  .use(router)
  .mount('#app')